import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, toImg } from "@/api/client";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="page-blog">
      <section className="container-cnp pt-14 lg:pt-20 pb-8">
        <span className="tag-chip">Blog</span>
        <h1 className="mt-4 font-display text-4xl md:text-5xl text-stone-900">Ideias e guias sobre o mercado no Porto</h1>
      </section>

      <section className="container-cnp pb-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-list-${p.slug}`} className="group card-soft overflow-hidden">
            <div className="aspect-[16/10] overflow-hidden bg-stone-100">
              <img src={toImg(p.main_image)} alt={p.title} className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
            </div>
            <div className="p-6">
              <span className="tag-chip">{p.category}</span>
              <h3 className="mt-3 text-lg text-stone-900 leading-snug">{p.title}</h3>
              <p className="mt-2 text-sm text-stone-600 line-clamp-2">{p.summary}</p>
              <div className="mt-4 text-xs text-stone-500">{p.author} · {new Date(p.date).toLocaleDateString("pt-PT")}</div>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
